/** @jsxImportSource react/jsx-runtime */
/** @jsxRuntime classic */
import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Typography,
  Grid,
  Container,
  Button,
  withStyles,
  Tooltip,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment";
import Paper from "@material-ui/core/Paper";
import PDFIcon from "@material-ui/icons/CloudDownload";
import NotesIcon from "@material-ui/icons/NoteAdd";
import Aux from "../../hoc/Auxilliary";
import { isObjectEmpty, paymentOptionList } from "../../utils/general";
import { useSelector, useDispatch } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import {
  getInvoiceData,
  getARReport,
  clearErrorStatusCode,
  clearErrorMessage,
  saveFileUploadData,
} from "../../reduxSlices/invoiceSlice";
import {
  getOptionList,
  getpreferredContactList,
} from "../../reduxSlices/applicationSlice";
import { clearLoginData, isLoggedInUpdate } from "../../reduxSlices/loginSlice";
import MessageIndicator from "../../components/SnackBar";
import Backdrop from "../../components/Backdrop/";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import config from "../../app/config";
import sha256 from "js-sha256";
import localizedStrings from "../../utils/localize";

import MyDocument from "./Document";
import Payments from "./Payments";
import ARReport from "./ARReport";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  container: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  profileFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    textAlign: "center",
    lineHeight: "2.5",
  },
  btnContainer: {
    display: "flex",
    gap: "6px",
  },
  btnStyle: {
    background: "#ffff",
    color: "#0b9ec1",
    "&:hover": {
      background: "#fff",
    },
  },
  taHeading: {
    background: "#005598 !important",
    fontWeight: "bold",
    fontSize: "15px",
    textAlign: "center",
    color: "#fff",
  },
  tAmount: {
    marginTop: "7px",
    textAlign: "end",
    fontSize: "21px",
  },
  tblStyle: {
    textAlign: "left",
  },
  tblStylecenter: {
    textAlign: "center",
  },
});

function convertCurrencyFormat(inputAmount) {
  if (typeof inputAmount !== "number") {
    inputAmount = Number(inputAmount); // If value is string
  }

  if (isNaN(inputAmount)) {
    return "Invalid input amount";
  }

  const isNegative = inputAmount < 0;
  const formattedAmount = Math.abs(inputAmount).toFixed(2);
  let result = `${formattedAmount.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " ")} $`;
  if (isNegative) {
    result = `(${result})`;
  }
  return result;
}

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

function Invoices(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [studentID, setStudentID] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPage1, setRowsPerPage1] = useState(5);
  const [page1, setPage1] = useState(0);
  const [paidInvoice, setPaidInvoice] = useState([]);
  const [unpaidInvoice, setUnpaidInvoice] = useState([]);
  const [arReport, setARReport] = useState([]);

  const [displayMessage, setDisplayMessage] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [studentId, setStudentId] = useState("");

  const getStudentDetails = useSelector(
    (state) => state.applicationData.applicantStatus.ses_applicantstatus,
  );

  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );

  useEffect(() => {
    if (getStudentDetails) {
      setStudentId(getStudentDetails.ses_studentid);
    }
  }, [getStudentDetails]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage1 = (event, newPage) => {
    setPage1(newPage);
  };

  const handleChangeRowsPerPage1 = (event) => {
    setRowsPerPage1(+event.target.value);
    setPage1(0);
  };
  const getPaidInvoiceData = useSelector(
    (state) => state.invoiceData.invoicePaidData,
  );
  const getARReportData = useSelector(
    (state) => state.invoiceData.arReportData,
  );
  const getUnpaidInvoiceData = useSelector(
    (state) => state.invoiceData.invoiceUnpaidData,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.invoiceData.dataFetchingStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const preferredContactList = useSelector(
    (state) => state.applicationData.preferredContactList,
  );
  const errorMessage = useSelector((state) => state.invoiceData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.invoiceData.errorStatusCode,
  );
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  useEffect(() => {
    let entity = "invoice";
    let attributename = "ses_invoicetype";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let entity = "invoice";
    let attributename = "statuscode";
    dispatch(getpreferredContactList(entity, attributename));
  }, [dispatch]);

  let amountData = "";
  let unpaidTableData = "";
  let paidTableData = "";
  if (unpaidInvoice.length > 0) {
    let amountPaidEuro = "0";
    let amountPaidEgypt = "0";
    const data = [
      { title: "One", prix: 100 },
      { title: "Two", prix: 200 },
      { title: "Three", prix: 300 },
    ];

    let sumofTotalAmount = unpaidInvoice.reduce(
      (total, currentValue) => (total = total + currentValue.totalamount),
      0,
    );
    let finalTotalAmount = sumofTotalAmount;
    let sumofAmountPaid = unpaidInvoice.reduce(
      (total, currentValue) => (total = total + currentValue.ses_amountpaid),
      0,
    );

    let finalAmountPaid = sumofAmountPaid;

    let finalTotalVariation = finalTotalAmount - finalAmountPaid;
    const fixedNumber = Number.parseFloat(finalTotalVariation).toFixed(2);
    let finalTotal = convertCurrencyFormat(fixedNumber);
    unpaidInvoice.map((row) => {
      if (
        row._transactioncurrencyid_value ===
        "4b40fd15-61f8-ea11-a815-000d3a654128"
      ) {
        amountPaidEuro =
          parseInt(amountPaidEuro) +
          parseInt(
            row.ses_totalchargedamount === null
              ? 0
              : row.ses_totalchargedamount,
          );
      } else {
        amountPaidEgypt =
          parseInt(amountPaidEgypt) +
          parseInt(
            row.ses_totalchargedamount === null
              ? 0
              : row.ses_totalchargedamount,
          );
      }
    });

    unpaidTableData =
      unpaidInvoice.length > 0
        ? unpaidInvoice
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => (
              <>
                {row.usb_verified && (
                  <TableRow key={index}>
                    <TableCell align="center">
                      {moment(
                        row[
                          "ses_invoicedate@OData.Community.Display.V1.FormattedValue"
                        ],
                      ).format("YYYY-MM-DD")}
                    </TableCell>
                    <TableCell align="center">{row.invoicenumber}</TableCell>
                    <TableCell align="center">
                      {convertCurrencyFormat(row.totalamount)}
                    </TableCell>
                    <TableCell align="center">
                      {convertCurrencyFormat(row.ses_amountpaid)}
                    </TableCell>
                    <TableCell align="center">
                      {convertCurrencyFormat(row.ses_amountremaining)}
                    </TableCell>
                    <TableCell align="center">{row.ses_term}</TableCell>

                    <TableCell align="center">
                      {row.ses_amountpaid === null ||
                      row.ses_amountpaid < row.totalamount ? (
                        <Typography
                          component="div"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "1rem",
                            width: "100%",
                          }}
                        >
                          <Typography>
                            <Typography component="div" align="center">
                              {row.usb_verified && (
                                <PDFDownloadLink
                                  document={<MyDocument data={row} />}
                                  fileName={row.invoicenumber + ".pdf"}
                                >
                                  {({ blob, url, loading, error }) =>
                                    loading ? (
                                      <Button
                                        variant="outlined"
                                        color="primary"
                                      >
                                        Loading document...
                                      </Button>
                                    ) : (
                                      <Button
                                        variant="outlined"
                                        color="primary"
                                      >
                                        <PDFIcon
                                          style={{
                                            fontSize: "20px",
                                            padding: 0,
                                            margin: 0,
                                            height: "4vh",
                                          }}
                                        />
                                      </Button>
                                    )
                                  }
                                </PDFDownloadLink>
                              )}
                            </Typography>
                          </Typography>
                        </Typography>
                      ) : (
                        <Typography
                          component="div"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "1rem",
                            width: "100%",
                          }}
                        >
                          <Typography>
                            <Typography component="div" align="center">
                              {row.usb_verified && (
                                <PDFDownloadLink
                                  document={<MyDocument data={row} />}
                                  fileName={row.invoicenumber + ".pdf"}
                                >
                                  {({ blob, url, loading, error }) =>
                                    loading ? (
                                      <Button
                                        variant="outlined"
                                        color="primary"
                                      >
                                        Loading document...
                                      </Button>
                                    ) : (
                                      <Button
                                        variant="outlined"
                                        color="primary"
                                      >
                                        <PDFIcon
                                          style={{
                                            fontSize: "20px",
                                            padding: 0,
                                            margin: 0,
                                            height: "4vh",
                                          }}
                                        />
                                      </Button>
                                    )
                                  }
                                </PDFDownloadLink>
                              )}
                            </Typography>
                          </Typography>
                        </Typography>
                      )}
                    </TableCell>
                  </TableRow>
                )}
              </>
            ))
        : null;

    amountData = (
      <div>
        <p className={classes.tAmount}>
          <span>{localizedStrings.account.total}: </span>
          <span> {finalTotal}</span>
        </p>
      </div>
    );
  }
  if (paidInvoice.length > 0) {
    paidTableData =
      paidInvoice.length > 0
        ? paidInvoice
            .slice(page1 * rowsPerPage1, page1 * rowsPerPage1 + rowsPerPage1)
            .map((row, index) => (
              <>
                <TableRow key={index}>
                  <TableCell align="center">
                    {moment(row.ses_paymentdate).format("YYYY-MM-DD")}
                  </TableCell>

                  <TableCell align="center">
                    {paymentOptionList(
                      row[
                        "ses_paymenttype@OData.Community.Display.V1.FormattedValue"
                      ],
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {convertCurrencyFormat(row.ses_paymentamt)}
                  </TableCell>
                  <TableCell align="center">{row.invoicenumber}</TableCell>
                  <TableCell align="center">
                    {row.usb_portalnotes === null && (
                      <Button
                        variant="outlined"
                        color="primary"
                        disabled="true"
                      >
                        <NotesIcon
                          style={{
                            fontSize: "20px",
                            padding: 0,
                            margin: 0,
                            height: "4vh",
                          }}
                        />
                      </Button>
                    )}

                    {row.usb_portalnotes !== null && (
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            <Typography
                              component="body"
                              style={{ fontSize: "0.75rem" }}
                            >
                              {row.usb_portalnotes}
                            </Typography>
                          </React.Fragment>
                        }
                      >
                        <Button variant="outlined" color="primary">
                          <NotesIcon
                            style={{
                              fontSize: "20px",
                              padding: 0,
                              margin: 0,
                              height: "4vh",
                              cursor: "pointer",
                            }}
                          />
                        </Button>
                      </HtmlTooltip>
                    )}
                  </TableCell>

                  <TableCell align="center">
                    {row.usb_verified && (
                      <PDFDownloadLink
                        document={<Payments data={row} />}
                        fileName={row.invoicenumber + ".pdf"}
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            <Button variant="outlined" color="primary">
                              Loading document...
                            </Button>
                          ) : (
                            <Button variant="outlined" color="primary">
                              <PDFIcon
                                style={{
                                  fontSize: "20px",
                                  padding: 0,
                                  margin: 0,
                                  height: "4vh",
                                }}
                              />
                            </Button>
                          )
                        }
                      </PDFDownloadLink>
                    )}
                  </TableCell>
                </TableRow>
                
              </>
            ))
        : null;
  }
  const InvData = () => {
    if (studentID.length > 0) {
      dispatch(
        getARReport(studentID, window.localStorage.getItem("x-auth-contactId")),
      );
      dispatch(
        getInvoiceData(
          studentID,
          window.localStorage.getItem("x-auth-contactId"),
        ),
      );
    }
  };

  useEffect(() => {
    InvData();
  }, [studentID]);
  function removeDuplicatesWithUSBVerifiedTrue(array) {
    const uniqueObjects = [];
    const trackingMap = {};

    array.forEach((obj) => {
      const key = `${obj.invoiceid}-${obj.ses_invoicedate}`;
      if (
        !trackingMap[key] &&
        !trackingMap[obj.productDetails] &&
        obj.usb_verified
      ) {
        trackingMap[key] = true;
        trackingMap[obj.productDetails] = true;
        uniqueObjects.push(obj);
      }
    });

    return uniqueObjects;
  }

  useEffect(() => {
    if (getUnpaidInvoiceData && getUnpaidInvoiceData.length > 0) {
      let removeDuplicateInvoices = getUnpaidInvoiceData;
      let unpaidInvoiceData = [...removeDuplicateInvoices].sort(
        (a, b) =>
          new Date(
            b["ses_invoicedate@OData.Community.Display.V1.FormattedValue"],
          ) -
          new Date(
            a["ses_invoicedate@OData.Community.Display.V1.FormattedValue"],
          ),
      );
      // Create a deep copy of unpaidInvoice to avoid modifying the original array
      const sortedUnpaidInvoice = JSON.parse(JSON.stringify(unpaidInvoiceData));

      // Sort each 'productDetails' array by 'name' property within it
      sortedUnpaidInvoice.forEach((item) => {
        if (item.productDetails && item.productDetails.length > 0) {
          item.productDetails.sort((a, b) => {
            const nameA = String(a.name).toLowerCase();
            const nameB = String(b.name).toLowerCase();
            return nameA.localeCompare(nameB);
          });
        }
      });

      // Now, sortedUnpaidInvoice has 'productDetails' arrays sorted by 'name'
      // Set the sorted data to the state
      setUnpaidInvoice(sortedUnpaidInvoice);
    }
    if (getPaidInvoiceData && getPaidInvoiceData.length > 0) {
      let removeDuplicatePaidInvoices = getPaidInvoiceData;
      let paidInvoiceData = [...removeDuplicatePaidInvoices].sort(
        (a, b) =>
          new Date(b["ses_paymentdate"]) - new Date(a["ses_paymentdate"]),
      );

      const filteredPayments = (paidInvoiceData || [])?.filter(
        (payment) => payment.usb_suppressonportal !== true
      );
      setPaidInvoice(filteredPayments);
    }
  }, [getPaidInvoiceData, getUnpaidInvoiceData]);

useEffect(() => {
  if (
    getARReportData &&
    (Array.isArray(getARReportData.invoices) || Array.isArray(getARReportData.payments))
  ) {
    const filteredPayments = (getARReportData.payments || [])?.filter(
      (payment) => payment.usb_suppressonportal !== true
    );

    setARReport({
      ...getARReportData,
      payments: filteredPayments,
    });
  }
}, [getARReportData]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };

  useEffect(() => {
    if (getStudentDetails) {
      setStudentID(getStudentDetails.ses_studentid);
    }
  }, [getStudentDetails]);

  useEffect(() => {
    if (error.message === "File Uploaded") {
      setDisplayMessage(localizedStrings.general.fileuploadMessage);
    } else if (error.message === "invalid student") {
      setDisplayMessage(localizedStrings.general.invalidstudentMessage);
    } else if (
      error.message === "Only Document type pdf/doc/docx/jpg/xlsx allowed"
    ) {
      setDisplayMessage(localizedStrings.general.invalidfiletypeMessage);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [error]);

  // Custom label for the "of" keyword in TablePagination
  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid className={classes.container}>
        <Container fixed>
          <Typography component="div" className={classes.profileFont}>
            {localizedStrings.account.unpaidinvoices}
          </Typography>

          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.taHeading} align="right">
                    {localizedStrings.account.date}
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    {localizedStrings.account.invoice}
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    {localizedStrings.account.totalamount}
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    {localizedStrings.account.amountpaid}
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    {localizedStrings.account.amountremaining}
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    {localizedStrings.account.term}
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    {localizedStrings.account.viewinvoice}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{unpaidTableData}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={unpaidInvoice.length > 0 ? unpaidInvoice.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage={
                <span style={{ textTransform: "none" }}>
                  {localizedStrings.rows.rowsperpage}
                </span>
              }
              labelDisplayedRows={customLabelDisplayedRows}
            />
          </TableContainer>
          {amountData}
        </Container>
      </Grid>
      <Grid className={classes.container}>
        <Container fixed>
          <Typography component="div" className={classes.profileFont}>
            {localizedStrings.account.payments}
          </Typography>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.taHeading}>
                    {localizedStrings.account.date}{" "}
                  </TableCell>
                  <TableCell className={classes.taHeading}>
                    {localizedStrings.account.type}
                  </TableCell>
                  <TableCell className={classes.taHeading}>
                    {localizedStrings.account.amount}
                  </TableCell>
                  <TableCell className={classes.taHeading}>
                    {localizedStrings.account.invoicenumber}
                  </TableCell>
                  <TableCell className={classes.taHeading}>
                    {localizedStrings.account.notes}
                  </TableCell>
                  <TableCell className={classes.taHeading}>
                    {localizedStrings.account.viewreceipt}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{paidTableData}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={paidInvoice.length > 0 ? paidInvoice.length : 0}
              rowsPerPage={rowsPerPage1}
              page={page1}
              onChangePage={handleChangePage1}
              onChangeRowsPerPage={handleChangeRowsPerPage1}
              labelRowsPerPage={
                <span style={{ textTransform: "none" }}>
                  {localizedStrings.rows.rowsperpage}
                </span>
              }
              labelDisplayedRows={customLabelDisplayedRows}
            />
          </TableContainer>
          <br />
          <br />
          <div style={{ textAlign: "right" }}>
            <PDFDownloadLink
              document={<ARReport data={arReport} />}
              fileName={"Relevé de compte" + ".pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? (
                  <Button variant="outlined" color="primary">
                    Loading document...
                  </Button>
                ) : (
                  <Button variant="outlined" color="primary">
                    {localizedStrings.account.accountsummary}
                    <PDFIcon
                      style={{
                        fontSize: "20px",
                        padding: 0,
                        marginLeft: 5,
                        height: "4vh",
                      }}
                    />
                  </Button>
                )
              }
            </PDFDownloadLink>
          </div>
        </Container>
      </Grid>
    </Aux>
  );
}

export default withRouter(Invoices);
